import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "news-press-releases" }
const _hoisted_2 = { class: "container mx-auto px-6 py-12" }
const _hoisted_3 = { class: "news-grid grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" }
const _hoisted_4 = { class: "news-image-wrapper overflow-hidden" }
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = { class: "news-content pt-4" }
const _hoisted_7 = { class: "news-date text-gray-500 text-sm mb-2" }
const _hoisted_8 = { class: "news-title text-xl font-semibold mb-3 text-gray-800 group-hover:text-blue-600 transition-colors" }
const _hoisted_9 = { class: "news-excerpt text-gray-600 mb-4 line-clamp-3" }
const _hoisted_10 = { class: "pagination mt-16 flex justify-center" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = ["disabled"]

import { ref, computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'NewsPressReleases',
  setup(__props) {

const newsList = [
  {
    date: "2025-12-20",
    title: "北境骑团发布2025年度骑行趋势报告",
    excerpt: "报告显示，山地骑行和长途骑行成为2025年最受欢迎的骑行方式，北境骑团将推出多款新品满足市场需求。",
    image: "https://images.unsplash.com/photo-1485965120184-e220f721d03e?w=800&h=400&fit=crop&crop=entropy"
  },
  {
    date: "2025-11-15",
    title: "北境骑团与国际骑行联盟达成战略合作",
    excerpt: "双方将在骑行赛事、技术研发和市场推广等方面展开深度合作，共同推动全球骑行运动发展。",
    image: "https://images.unsplash.com/photo-1519052537078-e6302a4968d4?w=800&h=400&fit=crop&crop=entropy"
  },
  {
    date: "2025-10-10",
    title: "北境骑团全新系列公路自行车正式发布",
    excerpt: "全新系列公路自行车采用最新碳纤维技术，轻量化设计，提供卓越的骑行体验，现已在全国各大门店上市。",
    image: "https://images.unsplash.com/photo-1507035895480-29c864a8824d?w=800&h=400&fit=crop&crop=entropy"
  },
  {
    date: "2025-09-05",
    title: "北境骑团2025秋季骑行活动圆满结束",
    excerpt: "本次活动吸引了来自全国各地的2000余名骑行爱好者参与，共同体验骑行乐趣，感受北境骑团的品牌魅力。",
    image: "https://images.unsplash.com/photo-1551103782-8ab07afd45c1?w=800&h=400&fit=crop&crop=entropy"
  },
  {
    date: "2025-08-20",
    title: "北境骑团荣获2025年度中国骑行品牌大奖",
    excerpt: "凭借卓越的产品质量和服务，北境骑团在众多品牌中脱颖而出，荣获2025年度中国骑行品牌大奖。",
    image: "https://images.unsplash.com/photo-1560250097-0b93528c311a?w=800&h=400&fit=crop&crop=entropy"
  },
  {
    date: "2025-07-15",
    title: "北境骑团宣布拓展国际市场",
    excerpt: "北境骑团将正式进军欧洲和北美市场，计划在未来三年内开设50家海外门店，将中国骑行文化推向世界。",
    image: "https://images.unsplash.com/photo-1449824913935-59a10b8d2000?w=800&h=400&fit=crop&crop=entropy"
  },
  {
    date: "2025-08-20",
    title: "北境骑团荣获2025年度中国骑行品牌大奖",
    excerpt: "凭借卓越的产品质量和服务，北境骑团在众多品牌中脱颖而出，荣获2025年度中国骑行品牌大奖。",
    image: "https://images.unsplash.com/photo-1560250097-0b93528c311a?w=800&h=400&fit=crop&crop=entropy"
  },
  {
    date: "2025-07-15",
    title: "北境骑团宣布拓展国际市场",
    excerpt: "北境骑团将正式进军欧洲和北美市场，计划在未来三年内开设50家海外门店，将中国骑行文化推向世界。",
    image: "https://images.unsplash.com/photo-1449824913935-59a10b8d2000?w=800&h=400&fit=crop&crop=entropy"
  },
  {
    date: "2025-08-20",
    title: "北境骑团荣获2025年度中国骑行品牌大奖",
    excerpt: "凭借卓越的产品质量和服务，北境骑团在众多品牌中脱颖而出，荣获2025年度中国骑行品牌大奖。",
    image: "https://images.unsplash.com/photo-1560250097-0b93528c311a?w=800&h=400&fit=crop&crop=entropy"
  },
  {
    date: "2025-07-15",
    title: "北境骑团宣布拓展国际市场",
    excerpt: "北境骑团将正式进军欧洲和北美市场，计划在未来三年内开设50家海外门店，将中国骑行文化推向世界。",
    image: "https://images.unsplash.com/photo-1449824913935-59a10b8d2000?w=800&h=400&fit=crop&crop=entropy"
  }
];

// Pagination
const currentPage = ref(1);
const pageSize = ref(6);

const totalPages = computed(() => {
  return Math.ceil(newsList.length / pageSize.value);
});

const paginatedNews = computed(() => {
  const start = (currentPage.value - 1) * pageSize.value;
  const end = start + pageSize.value;
  return newsList.slice(start, end);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[3] || (_cache[3] = _createElementVNode("h1", { class: "text-3xl font-bold mb-12 text-center text-gray-800" }, "新闻资讯", -1)),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paginatedNews.value, (news, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "news-item group"
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("img", {
                src: news.image,
                alt: news.title,
                class: "news-image w-full h-48 object-cover transition-transform duration-500 group-hover:scale-105"
              }, null, 8, _hoisted_5)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, _toDisplayString(news.date), 1),
              _createElementVNode("h3", _hoisted_8, _toDisplayString(news.title), 1),
              _createElementVNode("p", _hoisted_9, _toDisplayString(news.excerpt), 1),
              _cache[2] || (_cache[2] = _createElementVNode("a", {
                href: "#",
                class: "read-more text-blue-600 hover:underline font-medium inline-flex items-center"
              }, [
                _createTextVNode(" 查看详情 "),
                _createElementVNode("i", { class: "fas fa-arrow-right ml-1 transition-transform duration-300 group-hover:translate-x-1" })
              ], -1))
            ])
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("button", {
          class: "pagination-btn px-4 py-2 mx-1 rounded-md border border-gray-300 text-gray-600 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed",
          disabled: currentPage.value === 1,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (currentPage.value--))
        }, " 上一页 ", 8, _hoisted_11),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(totalPages.value, (page) => {
          return (_openBlock(), _createElementBlock("button", {
            key: page,
            class: _normalizeClass(["pagination-btn px-4 py-2 mx-1 rounded-md border transition-colors duration-200", currentPage.value === page ? 'bg-blue-600 text-white border-blue-600' : 'border-gray-300 text-gray-600 hover:bg-gray-50']),
            onClick: ($event: any) => (currentPage.value = page)
          }, _toDisplayString(page), 11, _hoisted_12))
        }), 128)),
        _createElementVNode("button", {
          class: "pagination-btn px-4 py-2 mx-1 rounded-md border border-gray-300 text-gray-600 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed",
          disabled: currentPage.value === totalPages.value,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (currentPage.value++))
        }, " 下一页 ", 8, _hoisted_13)
      ])
    ])
  ]))
}
}

})